import { render, staticRenderFns } from "./artigosEditar.vue?vue&type=template&id=c7edff36&scoped=true&"
import script from "./artigosEditar.vue?vue&type=script&lang=js&"
export * from "./artigosEditar.vue?vue&type=script&lang=js&"
import style0 from "./artigosEditar.vue?vue&type=style&index=0&id=c7edff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7edff36",
  null
  
)

export default component.exports